import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeContext } from '@common/contexts/ThemeStore';
import themes from '@theme';

const Theme = ({ children }) => {
	const { theme } = useContext(ThemeContext); // get the current theme ('light' or 'dark')

	const t = { ...themes };

	t['base']['primary'] =
		theme?.primaryColor?.hex || themes['base']['primary'];

	t['base']['shadow'] = theme?.shadowColor?.hex || themes['base']['shadow'];

	t['base']['component'] =
		theme?.componentBackground?.hex || themes['base']['component'];

	return <ThemeProvider theme={themes}>{children}</ThemeProvider>;
};

export default Theme;
